import React, { createContext, useState, useEffect } from 'react'
import { db } from './firebase'
import { collection, getDocs } from 'firebase/firestore/lite'

const Context = createContext()

export const Provider = ({ children }) => {
    const [globalState, setGlobalState] = useState({
        isModalOpen: false,
        signons: []
    })

    const fetchSignons = async () => {
        const signonsCol = collection(db, 'signons')
        const signonsSnapshot = await getDocs(signonsCol)
        const signonsData = signonsSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }))
        signonsData.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
        setGlobalState((prevState) => ({ ...prevState, signons: signonsData }))
    }

    useEffect(() => {
        fetchSignons() // Initial fetch
    }, [])

    return (
        <Context.Provider value={{ globalState, setGlobalState, fetchSignons }}>
            {children}
        </Context.Provider>
    )
}

export const useContext = () => {
    return React.useContext(Context)
}
